import React from 'react';
import PublicLayout from '../../components/public/PublicLayout';
import { BookOpen, FileText, Download } from 'lucide-react';

const PublicationsPage = () => {
  const publications = [
    {
      title: 'Respiratory Care Guidelines for Africa',
      description: 'Comprehensive clinical guidelines for respiratory therapy practice across African healthcare settings.',
      year: '2024',
      category: 'Clinical Guidelines',
      status: 'Coming Soon'
    },
    {
      title: 'ARCA Annual Report 2023',
      description: 'Our achievements, financial transparency, and impact across the continent.',
      year: '2023',
      category: 'Annual Reports',
      status: 'Coming Soon'
    },
    {
      title: 'COVID-19 Respiratory Management Protocol',
      description: 'Evidence-based protocols for managing respiratory complications in COVID-19 patients.',
      year: '2023',
      category: 'Research Papers',
      status: 'Coming Soon'
    },
    {
      title: 'Ventilator Best Practices Manual',
      description: 'Standardized protocols for mechanical ventilation in resource-limited settings.',
      year: '2024',
      category: 'Clinical Guidelines',
      status: 'Coming Soon'
    }
  ];

  return (
    <PublicLayout>
      <div className="py-5">
        <div className="container">
          {/* Header */}
          <div className="row justify-content-center text-center mb-5">
            <div className="col-lg-8">
              <div className="d-inline-flex align-items-center justify-content-center rounded-circle mb-4" 
                   style={{ width: '80px', height: '80px', backgroundColor: '#6B8E23' }}>
                <BookOpen className="text-white" size={40} />
              </div>
              <h1 className="display-4 fw-bold text-dark mb-3">Publications & Reports</h1>
              <p className="lead text-muted">
                Access our research papers, clinical guidelines, and annual reports
              </p>
            </div>
          </div>

          {/* Publications Grid */}
          <div className="row g-4 mb-5">
            {publications.map((pub, index) => (
              <div key={index} className="col-md-6">
                <div className="card h-100 shadow-sm border-0">
                  <div className="card-body p-4">
                    <div className="d-flex align-items-start mb-3">
                      <div className="d-inline-flex align-items-center justify-content-center rounded-circle me-3" 
                           style={{ width: '48px', height: '48px', backgroundColor: '#e8f5e9' }}>
                        <FileText style={{ color: '#6B8E23' }} size={24} />
                      </div>
                      <div className="flex-grow-1">
                        <h5 className="fw-bold text-dark mb-2">{pub.title}</h5>
                        <p className="text-muted small mb-2">{pub.description}</p>
                        <div className="d-flex align-items-center gap-3">
                          <span className="badge text-white" style={{ backgroundColor: '#6B8E23' }}>{pub.category}</span>
                          <span className="small text-muted">{pub.year}</span>
                          <span className="badge bg-warning text-dark">{pub.status}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Call to Action */}
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="card shadow border-0" style={{ background: 'linear-gradient(135deg, #6B8E23 0%, #556B1F 100%)' }}>
                <div className="card-body p-5 text-center text-white">
                  <h3 className="h4 fw-bold mb-3">More Publications Coming Soon</h3>
                  <p className="mb-4">
                    We are actively working on compiling comprehensive resources for our members. 
                    Subscribe to our newsletter to be notified when new publications are available.
                  </p>
                  <a href="/contact" className="btn btn-light btn-lg fw-bold">Contact Us for Information</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PublicLayout>
  );
};

export default PublicationsPage;
